import { GETAPI_SUCCESS } from '../types';

const initialState = {
  apiCodeData: []
};

export default function KeyManagerReducer(state = initialState, action) {
  switch (action.type) {
    case GETAPI_SUCCESS:
      return {
        ...state,
        apiCodeData: action.payload.data
      };
    default:
      return state;
  }
}
